import { Grid } from 'react-bootstrap';
import * as React from 'react';

export const MTAPremiumHasReferrals = () => {
  return (
    <div className="admiral-card">
      <div className="header">
        Sorry:
      </div>
      <div className="body">
        <Grid fluid={true}>
          <div>
            <p style={{ marginTop: '30px' }}>Unfortunately we are unable to make a change to your policy online.</p>
            <p>Please contact us if you’d like to discuss or make any changes. Our contact information can be found at <a className="pointer" href={'https://www.admiral.com/contact-us/travel'} target={'_blank'}>www.admiral.com/contact-us/travel</a>.</p>
            <p>It is important that your details are kept up to date, as incorrect information could affect your cover or any future claims.</p>
          </div>
        </Grid>
      </div>
    </div>
  )
}
